module.exports = __webpack_public_path__ + "img/tecla-atalho.3c9eedab.svg";